/**
 * Frise « Vous le recevez cette semaine ».
 *
 * Le CSS decrit l'etat FINAL. Ce module ajoute la classe `is-pre` (etat de
 * depart) puis la retire quand la frise entre dans le champ. Consequence : si
 * ce fichier ne s'execute pas (script bloque, erreur, navigateur ancien), la
 * classe n'est jamais posee et la section s'affiche complete. L'animation est
 * un bonus, jamais une condition d'affichage.
 *
 * Meme garde-fou que `lrs-mission.js` : une animation qui echoue doit rendre
 * la page VISIBLE, jamais l'inverse.
 */

const PRE = 'is-pre';
const THRESHOLD = 0.35;

let renonce = false;

/** Retire `is-pre` partout et interdit toute nouvelle pose. */
function toutAfficher(cause) {
  renonce = true;
  try {
    document.querySelectorAll('.' + PRE).forEach((el) => el.classList.remove(PRE));
  } catch (_) {
    /* dernier recours : ne rien laisser remonter */
  }
  if (cause) console.warn('[LRS] animation abandonnee, contenu rendu visible :', cause);
}

/** Enveloppe une fonction : au moindre jet, la page redevient visible. */
function sansCasse(fn) {
  return function wrapped(...args) {
    if (renonce) return undefined;
    try {
      return fn.apply(this, args);
    } catch (error) {
      toutAfficher(error);
      return undefined;
    }
  };
}

/**
 * Le visiteur a-t-il deja atteint cet element ?
 *
 * Ce module est differe : sur une connexion lente il s'execute APRES que le
 * visiteur a commence a defiler. Masquer alors une section deja depassee est
 * sans retour, parce qu'un IntersectionObserver ne se declenche qu'a l'ENTREE
 * dans le champ et jamais pour ce qui est deja passe.
 */
function dejaAtteint(el) {
  const haut = window.innerHeight || document.documentElement.clientHeight || 0;
  return el.getBoundingClientRect().top < haut;
}

/**
 * Cet element aurait-il du etre revele ?
 *
 * On rejoue la condition de l'observateur plutot qu'une plus lache : reveler
 * des le premier pixel supprimerait l'animation au lieu de la sauver. Seule
 * exception, un element entierement depasse : plus personne ne le revelera.
 */
function auraitDuEtreVu(el) {
  const r = el.getBoundingClientRect();
  const vh = window.innerHeight || document.documentElement.clientHeight || 0;
  if (r.bottom < 0) return true;
  if (!r.height) return false;
  const visible = Math.min(r.bottom, vh) - Math.max(r.top, 0);
  return visible / r.height >= THRESHOLD;
}

/**
 * Balayage de secours, independant de l'observateur.
 *
 * Sans effet quand tout va bien : l'observateur a deja retire la classe avant
 * que le balayage n'y arrive. Il couvre le cas ou l'observateur n'a jamais vu
 * passer la frise, typiquement un module arrive apres le defilement.
 */
function filet() {
  const restants = document.querySelectorAll('.lrs-steps.' + PRE);
  if (!restants.length) return;
  restants.forEach((el) => {
    if (auraitDuEtreVu(el)) el.classList.remove(PRE);
  });
}

// Le module n'a pas de boucle a lui : on accroche le balayage au defilement,
// limite a un tour de rendu. Au-dessus de 990 px Horizon fait defiler
// `.page-wrapper` et non la fenetre : l'ecoute se fait en phase de capture
// sur le document, qui voit passer les deux.
let enAttente = false;
const auDefilement = () => {
  if (renonce || enAttente) return;
  enAttente = true;
  requestAnimationFrame(() => {
    enAttente = false;
    sansCasse(filet)();
  });
};
document.addEventListener('scroll', auDefilement, { capture: true, passive: true });
window.addEventListener('scroll', auDefilement, { passive: true });
window.addEventListener('resize', auDefilement, { passive: true });

const arm = sansCasse(function arm(list) {
  if (!('IntersectionObserver' in window)) return;

  list.forEach((el) => {
    if (el.dataset.lrsSteps === 'on') return;
    el.dataset.lrsSteps = 'on';

    // Deja atteint : on n'a plus le droit de le masquer. Voir `dejaAtteint`.
    if (dejaAtteint(el)) return;

    el.classList.add(PRE);

    const observer = new IntersectionObserver(
      sansCasse((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.remove(PRE);
          // once: la frise ne se rejoue pas au second passage.
          observer.unobserve(entry.target);
        });
      }),
      { threshold: THRESHOLD }
    );

    observer.observe(el);
  });
});

const scan = sansCasse(function scan(root) {
  arm(Array.from((root || document).querySelectorAll('.lrs-steps')));
});

scan(document);

// L'editeur de theme re-rend la section : il faut ré-armer la nouvelle copie.
document.addEventListener('shopify:section:load', (event) => scan(event.target));

// Une erreur levee hors de nos enveloppes ne doit pas laisser la page coupee.
window.addEventListener('error', (event) => {
  if (renonce) return;
  const src = String((event && event.filename) || '');
  if (src.includes('/lrs-')) toutAfficher(event.message);
});

/* Filets de rattrapage. Sans effet quand tout va bien. */
setTimeout(sansCasse(filet), 2500);
window.addEventListener('load', () => setTimeout(sansCasse(filet), 1500));
window.addEventListener('pageshow', (event) => {
  if (event.persisted) sansCasse(filet)();
});
